














import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class NavBarMenu extends Vue {
  @Prop({
    default: false,
  })
  public isHoverable!: boolean;

  public isDropdownActive = false;

  public get toggleDropdownIcon(): string {
    return this.isDropdownActive ? 'chevron-up' : 'chevron-down';
  }

  public created(): void {
    window.addEventListener('click', (e) => this.forceClose(e));
  }
  public beforeDestroy(): void {
    window.removeEventListener('click', (e) => this.forceClose(e));
  }

  public toggle(): void {
    if (!this.isHoverable) {
      this.isDropdownActive = !this.isDropdownActive;
    }
  }

  public forceClose(e: MouseEvent): void {
    if (!this.$el.contains(e.target as Node)) {
      this.isDropdownActive = false;
    }
  }
}
